import {
  Currency,
  type CurrencyName,
} from '@webapp/core/entities/external/Currency'
import { type ExpenseDraftConstructor } from '@webapp/modules/expense/entities/ExpenseDraft'
import { type ExpenseDraftApiModel } from '../api-models/ExpenseDraftApiModel'

export const mapExpenseDraftApiModel = (
  api: ExpenseDraftApiModel
): ExpenseDraftConstructor => ({
  id: api.id,
  uuid: api.uuid,
  title: api.title,
  status: api.status,
  departmentId: api.department_id,
  locationId: api.department?.branch_id ?? 0,
  nextApproverId: api.next_approver_id ?? null,
  travel: api.travel ?? null,
  notes: api.notes ?? '',
  createdDate: api.createdDate ?? '',
  items: (api.items || []).map((item) => ({
    id: item.id,
    merchant: item.merchant,
    accountId: item.account_id,
    reimbursable: item.reimburse,
    expenseType: item.expense_type,
    paymentType: item.paymentType,
    amount: parseFloat(item.amount),
    taxPercentage: item.tax_percentage,
    taxName: item.tax_name ?? '%',
    currency: new Currency({
      id: item.localCurrency.id,
      name: item.localCurrency.name as CurrencyName,
      rate: parseFloat(item.localCurrency.rate),
    }),
    transactionDate: item.transDate ?? '',
    attachment: item.attachment ?? '',
    notes: item.notes ?? '',
    expenseTypeFields: item.expense_type_fields ?? null,
    taxAmount: parseFloat(item.tax_amount ?? '0'),
    taxId: item.tax_id ?? null,
    creditCardId: item.creditcard_id ?? null,
    account: item.account
      ? {
          id: item.account.id,
          accountCode: {
            id: item.account.account_code.id,
            code: item.account.account_code.code,
            description: item.account.account_code.description,
          },
        }
      : null,
    creditCard: item.creditcard
      ? {
          id: item.creditcard.id,
          name: item.creditcard.name,
          number: item.creditcard.number,
          type: item.creditcard.type,
        }
      : null,
  })),
})
